export default __webpack_public_path__ + "static/media/Kate_Baucherel_AHV_In_Moms_We_Trust.f6e220c4.jpg";